import { render } from "./ClaimsSearch.vue?vue&type=template&id=7da0df46&scoped=true&ts=true"
import script from "./ClaimsSearch.vue?vue&type=script&lang=ts"
export * from "./ClaimsSearch.vue?vue&type=script&lang=ts"

import "./ClaimsSearch.vue?vue&type=style&index=0&id=7da0df46&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da0df46"]])

export default __exports__